import { render } from "./GlobalHeadAction.vue?vue&type=template&id=72bc52ee"
import script from "./GlobalHeadAction.vue?vue&type=script&lang=js"
export * from "./GlobalHeadAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__